{
 "id": "shark",
 "class": "swimmer",
 "size": {
  "w": 40,
  "h": 40
 },
 "anchor": {
  "x": 19,
  "y": 20
 },
 "palette": {
  "k": "#18100b",
  "n": "#23140b",
  "y": "#1a0f09",
  "i": "#14110f",
  "D": "#2c4a7a",
  "B": "#4a78b0",
  "L": "#7aa8d8",
  "H": "#addaf0",
  "W": "#dff1fa",
  "T": "#1f4f5a",
  "t": "#2f7d86",
  "g": "#4a4540",
  "G": "#7a736b",
  "s": "#aaa399",
  "S": "#d6d0c6",
  "w": "#f5f1e8",
  "c": "#ebe2d5",
  "r": "#731c1c",
  "R": "#a82c2c",
  "p": "#ad4459"
 },
 "frames": {
  "swim_0": [
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "..kkk...........kkk.....................",
   "..kLBk..........kHLk....................",
   "...kLBk.........kHLBk...................",
   "...kDLBk........kHLLBk..................",
   "....kDLBk......kkHLLLBk.................",
   "....kDLBBk...kkkHLLLBBBkkkkkkk..........",
   ".....kDLBBkkkkHHHLLLLLBBBBBBBDkkk.......",
   "......kDLBBBBBHHHLLLLLBBBBBBBBLLLkk.....",
   "......kDDBBBBBLLLLBBBBBBBBBBBBLWiBBkk...",
   ".....kDLBBBBBBBBBBBBBBBBnBnBnBLiiBBDkk..",
   "....kDLttttttttttttttttBnBnBnBLLBBBDsck.",
   "...kDLBtkkkkSSSSSSSSwwwwwwwwwwnnwwwnwck.",
   "..kkDLBk....kkkSSSScwwwwwwwwwwwwnnnckk..",
   "..kDBkk........kLBBBDsswwwwwwwwwwwckk...",
   "..kkk..........kLBBBBDkkTTkkkkkkkkk.....",
   "...............kLBBBDk.kTTk.............",
   "...............kLBBDk...kk..............",
   "...............kBBDk....................",
   "...............kkkk.....................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................"
  ],
  "swim_1": [
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "................kkk.....................",
   "................kHLk....................",
   "................kHLBk...................",
   "..kkk...........kHLLBk..................",
   "..kLBk.........kkHLLLBk.................",
   "...kLBk......kkkHLLLBBBkkkkkkk..........",
   "...kDLBk...kkkHHHLLLLLBBBBBBBDkkk.......",
   "....kDLBkkkkBkHHHLLLLLBBBBBBBBLLLkk.....",
   ".....kDLBBBBBLLLLBBBBBBBBBBBBBLWiBBkk...",
   "......kDDBBBBBBBBBBBBBBBnBnBnBLiiBBDkk..",
   "......kDTttttttttttttttBnBnBnBLLBBBDsck.",
   ".....kDLtTttttttSSSSSSSSwwwwwwnnwwwnwck.",
   "....kDLBtTkkkkkSSSScwwwwwwwwwwwwnnnckk..",
   "...kkDLBBtk...kLBBBDsswwwwwwwwwwwwckk...",
   "..kkDLBBkk....kLBBBBDkkTTkkkkkkkkkk.....",
   "..kDLBBk......kLBBBDk.kTTk..............",
   "..kDBkk.......kBBDkk...kk...............",
   "..kkk.........kkkk......................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................"
  ],
  "swim_happy_0": [
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "..kkk...........kkk.....................",
   "..kLBk..........kHLk....................",
   "...kLBk.........kHLBk...................",
   "...kDLBk........kHLLBk..................",
   "....kDLBk......kkHLLLBk.................",
   "....kDLBBk...kkkHLLLBBBkkkkkkk..........",
   ".....kDLBBkkkkHHHLLLLLBBBBBBBDkkk.......",
   "......kDLBBBBBHHHLLLLLBBBBBBBBLLLkk.....",
   "......kDDBBBBBLLLLBBBBBBBBBBBBLwWiBkk...",
   ".....kDLBBBBBBBBBBBBBBBBnBnBnBLiiiBDkk..",
   "....kDLttttttttttttttttBnBnBnBLLBBDnsck.",
   "...kDLBtkkkkSSSSSSSSwwwwwwwwwwnnwwncwck.",
   "..kkDLBk....kkkSSSScwwwwwwwwwwwwnnwckk..",
   "..kDBkk........kLBBBDsswwwwwwwwwwwckk...",
   "..kkk..........kLBBBBDkkTTkkkkkkkkk.....",
   "...............kLBBBDk.kTTk.............",
   "...............kLBBDk...kk..............",
   "...............kBBDk....................",
   "...............kkkk.....................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................"
  ],
  "swim_happy_1": [
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "................kkk.....................",
   "................kHLk....................",
   "................kHLBk...................",
   "..kkk...........kHLLBk..................",
   "..kLBk.........kkHLLLBk.................",
   "...kLBk......kkkHLLLBBBkkkkkkk..........",
   "...kDLBk...kkkHHHLLLLLBBBBBBBDkkk.......",
   "....kDLBkkkkBkHHHLLLLLBBBBBBBBLLLkk.....",
   ".....kDLBBBBBLLLLBBBBBBBBBBBBBLwWiBkk...",
   "......kDDBBBBBBBBBBBBBBBnBnBnBLiiiBDkk..",
   "......kDTttttttttttttttBnBnBnBLLBBDnsck.",
   ".....kDLtTttttttSSSSSSSSwwwwwwnnwwncwck.",
   "....kDLBtTkkkkkSSSScwwwwwwwwwwwwnnwckk..",
   "...kkDLBBtk...kLBBBDsswwwwwwwwwwwwckk...",
   "..kkDLBBkk....kLBBBBDkkTTkkkkkkkkkk.....",
   "..kDLBBk......kLBBBDk.kTTk..............",
   "..kDBkk.......kBBDkk...kk...............",
   "..kkk.........kkkk......................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................"
  ],
  "eat": [
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "..kkk...........kkk.....................",
   "..kLBk..........kHLk....................",
   "...kLBk.........kHLBk...................",
   "...kDLBk........kHLLBk..................",
   "....kDLBk......kkHLLLBk.................",
   "....kDLBBk...kkkHLLLBBBkkkkkkk..........",
   ".....kDLBBkkkkHHHLLLLLBBBBBBBDkkkk......",
   "......kDLBBBBBHHHLLLLLBBBBBBBBLLLLkkk...",
   "......kDDBBBBBLLLLBBBBBBBBBBBBLWiBBDkk..",
   ".....kDLBBBBBBBBBBBBBBBBnBnBnBLiiBBBDsk.",
   "....kDLttttttttttttttttBnBnBnBLBBBnWckk.",
   "...kDLBtkkkkSSSSSSSSwwwwwwwwwwnWnWnnk...",
   "..kkDLBk....kkkSSSScwwwwwwwwwnnnnnnk....",
   "..kDBkk........kLBBBDsswwwwwwwwnnnnk....",
   "..kkk..........kLBBBBDkkTTkkkSwrRWnWk...",
   "...............kLBBBDk.kTTk.kkSwwwwck...",
   "...............kLBBDk...kk....kkkkkk....",
   "...............kBBDk....................",
   "...............kkkk.....................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................"
  ],
  "rest": [
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "................kkk.....................",
   "................kHLk....................",
   "..kkk...........kHLBk...................",
   "..kLBkk.........kHLLBk..................",
   "...kDLBk.......kkHLLLBk.................",
   "....kDLBk....kkkHLLLBBBkkkkkkk..........",
   ".....kDLBk.kkkHHHLLLLLBBBBBBBDkkk.......",
   ".....kDLBkkkBkHHHLLLLLBBBBBBBBLLLkk.....",
   "......kDLBBBBBLLLLBBBBBBBBBBBBLLLLBkk...",
   "......kDDBBBBBBBBBBBBBBBnBnBnBLnnnBDkk..",
   ".....kDLttttttttttttttttBnBnBnBLLBBDsck.",
   "....kDLBtkkkkSSSSSSSSwwwwwwwwwwwwwwwwck.",
   "...kkDLBk....kkkSSSScwwwwwwwwwnnnnnckk..",
   "...kDBkk........kLBBBDsswwwwwwwwwwckk...",
   "...kkk..........kLBBBBBDkTTDkkkkkkk.....",
   "................kLBBBBkk.kTTk...........",
   "................kBBBDk....kk............",
   "................kkkkk...................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................"
  ],
  "sad_0": [
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "................kkk.....................",
   "................kHLk....................",
   "................kHLBk...................",
   "..kkk...........kHLLBk..................",
   "..kLBk.........kkHLLLBk.................",
   "...kLBk......kkkHLLLBBBkkkkk............",
   "...kDLBk...kkkHHHLLLLLBBBBBDkkkkk.......",
   "....kDLBkkkkBkHHHLLLLLBBBBBBBBBBDkk.....",
   ".....kDLBBBBBLLLLBBBBBBBBBBBBBBBBLBkk...",
   "......kDDBBBBBBBBBBBBBBBnBnBnBLggBBDkk..",
   "......kDTtttttttttttttttBnBnBnBiiBBBDsk.",
   ".....kDLtTttttttSSSSSSSSwwwwwwwLLBBBsck.",
   "....kDLBtTkkkkkSSSScwwwwwwwwwwnnnwwwwck.",
   "...kkDLBBtk....kLBBBDsswwwwwwwwwwnnckk..",
   "..kkDLBBkk.....kLBBBBBDkTTDkkwwwwwwkk...",
   "..kDLBBk.......kLBBBBDk.kTTk.kkkkkkk....",
   "..kDBkk........kLBBBDk...kk.............",
   "..kkk..........kLBBDk...................",
   "...............kBBDk....................",
   "...............kkkk.....................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................",
   "........................................"
  ]
 }
}
